require('./paymentChoreStep.scss');
// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');

// @ commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');

// @actions
const openYoungCardPaymentChore = require('actions/openYoungCardPaymentChore');

// @ utilities
const currencyHelper = require('utilities/currencyHelper');
const { toCamelCase } = require('utilities/stringHelper');

class PaymentChoreStep2 extends React.Component {
    constructor(props){
        super(props);
        this.createList = this.createList;
        this.handleSetRemark = this.handleSetRemark.bind(this);
    }

    createList(list) {
        return list.filter(({ bodyText }) => bodyText ).map( (item, key) => (
            <OKInformativeListItem
                className={"payment-chores-step__list-item"} 
                key={key}
                title={item.title}
                bodyText={item.bodyText}
                bodyWordBreak={false}
            />
        ));
    }

    handleSetRemark(event){
        const remark = event.target.value;
        this.props.setRemark(remark);
    }

    render() {
        const { immStep, immAccounts, choreDetail } = this.props;
        const currency = currencyHelper.formatCurrency('EUR');
        const amount = currencyHelper.getFormattedString({ amount: immStep.get('amount'), currency });
        const fromAccount = immStep.get('fromAccount');
        const originAccount = immAccounts.get(fromAccount);
        const originAccountAlias = originAccount.get('alias') || toCamelCase(originAccount.get('accountType'));
        const originAccountText = `${originAccountAlias} ...${originAccount.get('iban').substr(-4)}`;
        const taskType = formatText(`openYoungCardChores-task${choreDetail.getIn(['chore','choreId'])}`)
        const list = [
            {
                title: formatText('openYoungPaymentChores-chore'),
                bodyText: taskType
            },
            {
                title: formatText('openYoungPaymentChores-numeroOriginAccount'),
                bodyText: originAccountText
            },
            {
                title: formatText('openYoungPaymentChores-amount'),
                bodyText: amount
            },
            {
                title: formatText('openYoungPaymentChores-concept'),
                bodyText: immStep.get('remark')
            }
        ];

        return (
            <article className="payment-chores-step">
                <section>
                    <h2 className="payment-chores-step__heading">
                        <FormattedText value="openYoungPaymentChores-confirmation"/>
                    </h2>
                    <p className="payment-chores-step__paragraph">
                        <FormattedText value="openYoungPaymentChores-confirmationText"/>
                    </p>
                </section>
                <section className="payment-chores-step__main">
                    <OKInformativeList columns={2}>
                        {this.createList(list)}
                    </OKInformativeList>
                </section>
            </article>
        );
    }
}
  
PaymentChoreStep2.propTypes = {
    childName: PropTypes.string,
    choreDetail: PropTypes.object,
    immAccounts: PropTypes.object,
    immStep: PropTypes.object.isRequired,
    setRemark: PropTypes.func
}
module.exports.PaymentChoreStep2 = connect(
    null,
    {
        setRemark: openYoungCardPaymentChore.setRemark
    })(PaymentChoreStep2);
